import { render } from "./ThresholdInfo.vue?vue&type=template&id=8fd1f140"
import script from "./ThresholdInfo.vue?vue&type=script&lang=js"
export * from "./ThresholdInfo.vue?vue&type=script&lang=js"

import "./ThresholdInfo.vue?vue&type=style&index=0&id=8fd1f140&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__